<script setup lang="ts">
import { Badge } from '@/components/ui/badge';
import { formatRelativeTime } from '~/lib/formatters';

const props = defineProps<{
    title?: string;
    actorName?: string;
    channelLabel?: string;
    body: string;
    timestamp?: unknown;
}>();
</script>

<template>
    <div class="rounded-xl border border-border/70 bg-background/76 px-3 py-3">
        <div class="flex flex-wrap items-center justify-between gap-2">
            <div class="min-w-0">
                <p v-if="title" class="text-sm font-medium text-foreground">{{ title }}</p>
                <p class="text-xs text-muted-foreground">{{ actorName || 'Client update' }}</p>
            </div>
            <div class="flex items-center gap-2">
                <Badge v-if="channelLabel" variant="outline">{{ channelLabel }}</Badge>
                <p v-if="timestamp" class="text-xs text-muted-foreground">{{ formatRelativeTime(timestamp, 'recently') }}</p>
            </div>
        </div>
        <p class="mt-3 whitespace-pre-wrap text-sm leading-6 text-foreground">{{ body }}</p>
    </div>
</template>
